module.exports = __webpack_public_path__ + "assets/img/warrior-name-5e1d974e.png";